import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useNonMoldContext() {
  const { nonMolds } = useContext<GlobalContextType>(GlobalContext);
  return nonMolds;
}
